<template>
  <div class="container">
    <div v-if="!loading">
      <h1 class="text-center">
        <i style="color: #77c778" class="fa fa-2x fa-check-circle-o" />
      </h1>
      <h1 style="margin-top: 0px" class="text-center">
        Payment successful, thank you
      </h1>
      <div class="card text-center col-md-offset-3 col-md-6">
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: right; margin-right: 5px">
            Invoice No:
          </p>
        </div>
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: left; margin-left: 5px">
            <strong>{{ subscriptionDto.InvoiceNumber }}</strong>
          </p>
        </div>
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: right; margin-right: 5px">
            Total Amount:
          </p>
        </div>
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: left; margin-left: 5px">
            <strong>${{ subscriptionDto.TotalAmount }}</strong>
          </p>
        </div>
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: right; margin-right: 5px">
            Payment Date:
          </p>
        </div>
        <div class="col-xs-6 remove-margins">
          <p style="display: inline-block; float: left; margin-left: 5px">
            <strong>{{ paymentDateComp }}</strong>
          </p>
        </div>
        <p>
          <strong>{{ subscriptionDto.Description }}</strong> valid until
          <strong>{{ endDateComp }}</strong>
        </p>
      </div>
      <div
        style="margin-top: 0px; padding: 0px"
        class="col-md-6 col-md-offset-3"
      >
        <p class="text-center">
          Details will be sent shortly to
          <strong>{{ subscriptionDto.Email }}</strong>
        </p>
      </div>
      <div
        style="margin-top: 15px; padding: 0px"
        class="col-md-6 col-md-offset-3"
      >
        <button @click="goHome()" class="btn btn-success btn-block">
          Go home
        </button>
      </div>
    </div>
    <div v-if="loading">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../../auth/index";
import store from "../../data/store";
import commonApi from "../../services/commonApi.js";

export default {
  name: "success",
  data() {
    return {
      subscriptionDto: "",
      loading: true,
    };
  },
  mounted() {
    var self = this;
    self.initSubscription(this.$route.params.subscriptionId);
  },
  updated() {
    var self = this;
    $("input").focus(function () {
      self.scrollPosition = window.scrollY;
    });
    $("input").blur(function () {
      // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
      self.$SmoothScroll(self.scrollPosition, 350);
    });

    // $zopim(function() {
    //     $zopim.livechat.badge.hide();
    // });
  },
  methods: {
    goHome: function () {
      this.$router.push({ path: "/" });
    },
    initSubscription: function (subscriptionId) {
      var self = this;
      return $.ajax({
        type: "GET",
        url:
          "https://www.dupaws.com/services/api/initSubscription/" +
          subscriptionId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        crossDomain: true,
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.subscriptionDto = data;
          self.loading = false;
          commonApi.initUserSubscription();
        },
        error: function (data, status, error) {
          try {
            swal("Error", data.responseJSON.Message, "error");
            self.goHome();
          } catch (e) {
            swal("Error", e, "error");
            self.goHome();
          }
        },
      });
    },
  },
  computed: {
    authenticatedComp: function () {
      return store.getters.authenticated;
    },
    userRoleComp: function () {
      return store.getters.userRole;
    },
    endDateComp: function () {
      var self = this;
      return moment(self.subscriptionDto.EndDate).format("DD MMM YYYY");
    },
    paymentDateComp: function () {
      var self = this;
      return moment(self.subscriptionDto.PaymentDate).format("DD MMM YYYY");
    },
  },
  components: {},
};
</script>

<style scoped>
.card {
  /* Add shadows to create the "card" effect */
  margin-bottom: 20px;
  transition: 0.3s;
  border: 1px;
  padding: 10px;
  border-radius: 5px;
  border-style: solid;
  overflow: hidden;
  border-color: #c7c6c6;
}
</style>



// WEBPACK FOOTER //
// Success.vue?2f654573